
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M240.091 272.273c75.186 0 136.137-60.95 136.137-136.136C376.229 60.951 315.277 0 240.091 0S103.955 60.951 103.955 136.137c0 75.187 60.95 136.136 136.136 136.136zm0-250.615c63.225 0 114.479 51.254 114.479 114.479s-51.254 114.479-114.479 114.479-114.479-51.253-114.479-114.479c0-63.224 51.255-114.479 114.479-114.479zm189.856 302.817a218.82 218.82 0 00-14.963-15.594l-.014.005.001.001c-.022.008-.046.02-.067.025.021-.007.044-.017.066-.026-13.867-13.099-29.627-24.659-46.934-34.312a249.39 249.39 0 00-20.699-10.301c-29.154 24.188-66.596 38.732-107.437 38.732-40.962 0-78.502-14.633-107.694-38.951a250.142 250.142 0 00-20.722 10.258C45.06 311.164 1 375.842 1 449.477c0 4.348.172 8.658.475 12.939h365.54c-6.428-13.039-10.054-27.707-10.054-43.229 0-45.462 30.985-83.681 72.986-94.712zm-92.332 94.713c0 7.578.725 14.986 2.104 22.162.006.096-11.14.082-11.14.082l-294.005-.156s-11.252-.107-11.257-.061C27.01 376.686 68.34 319.473 128.31 288.102c31.317 22.814 69.879 36.281 111.591 36.281 41.572 0 80.017-13.375 111.278-36.051 15.986 8.408 30.609 18.576 43.542 30.178.003-.002.005-.004.009-.004-34.211 20.482-57.115 57.906-57.115 100.682zm161.091-19.809h-30.283v-28.764c0-6.791-5.527-12.293-12.347-12.293-6.818 0-12.346 5.502-12.346 12.293v28.764h-29.409c-6.789 0-12.293 5.545-12.293 12.383 0 6.84 5.504 12.383 12.293 12.383h29.409V455c0 6.789 5.527 12.295 12.346 12.295s12.347-5.506 12.347-12.295v-30.855h30.283c6.79 0 12.294-5.543 12.294-12.383 0-6.838-5.504-12.383-12.294-12.383z"}})])
          )
        }
      }
    